import React, {useState} from 'react';
import NotificationsService from '../services/notificationsService';

export const NotificationsContext = React.createContext();

const NotificationsContextProvider = ({ children }) => {
  const [pending, setPending] = useState(false);
  const [markAsReadPending, setMarkAsReadPending] = useState(false);
  const [error, setError] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [isNotificationUnread, setIsNotificationUnread] = useState(false);

  const getNotifications = async () => {
    setError(false);
    setPending(true);
    const responseObj = await NotificationsService.getNotifications();

    if (responseObj.type === 'Error') {
      setError(true);
    } else {
      setNotifications(responseObj);
      setIsNotificationUnread(!!responseObj.filter(item => !item?.read).length);
    }

    setPending(false);

    return responseObj;
  };

  const markNotificationsAsRead = async () => {
    setError(false);
    setMarkAsReadPending(true);
    const responseObj = await NotificationsService.markNotificationsAsRead();

    if (responseObj.type === 'Error') {
      setError(true);
    } else {
      setIsNotificationUnread(false);
    }

    setMarkAsReadPending(false);

    return responseObj;
  };

  return (
    <NotificationsContext.Provider
      value={{
        pending,
        error,
        notifications,
        getNotifications,
        isNotificationUnread,
        markNotificationsAsRead,
        markAsReadPending
      }}
    >
      {children}
    </NotificationsContext.Provider>
  );
};

export default NotificationsContextProvider;
